import type { FC, SVGProps } from 'react';

const InformationRoundedIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="5.5"
        stroke="currentColor"
      />
      <path
        d="M13.2806 10.5561L11.0132 10.8402L10.9321 11.2171L11.3786 11.2983C11.6685 11.3679 11.7265 11.4723 11.6627 11.7622L10.9321 15.1952C10.7407 16.0825 11.0364 16.5 11.7323 16.5C12.2716 16.5 12.8979 16.2506 13.1821 15.9085L13.269 15.4968C13.0719 15.6707 12.7819 15.7403 12.5906 15.7403C12.318 15.7403 12.2194 15.549 12.289 15.2126L13.2806 10.5561Z"
        fill="currentColor"
      />
      <path
        d="M13.3492 8.48969C13.3492 9.03628 12.9061 9.47938 12.3595 9.47938C11.8129 9.47938 11.3698 9.03628 11.3698 8.48969C11.3698 7.9431 11.8129 7.5 12.3595 7.5C12.9061 7.5 13.3492 7.9431 13.3492 8.48969Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InformationRoundedIcon;
